module.exports = Object.create;